var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"column":""}},_vm._l((_vm.filteredCharts),function(chart,index){return _c('entity-chart-widget',{key:index,attrs:{"widget":chart,"entity":_vm.entity,"available-metrics":_vm.availableMetrics}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }